import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const HighlightsBylineButton: LoadableType<{
	contentId: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-HighlightsBylineButton" */
				'../src/HighlightsBylineButton.tsx'
			)
		).HighlightsBylineButton,
});
